import { TitlePageH1, useFetchData } from '@tap/mui-ui';
import { useEffect } from 'react';
import { Grid } from '@mui/material';
import StatisticsWidget from './StatisticsWidget';
import BeginningWorkWidget from './BeginningWorkWidget';
import { HomeFilter, defaultFilterValue } from './HomeFilter';
import DecisionTimeWidget from './DecisionTimeWidget';
import { DataCollectionCode, dataCollectionService } from '@tap/data-providers';

/*
*   Главная
*/

const filterProviderProps = {
    useQueryParams: true,
    defaultValue: defaultFilterValue,
};

type IHomePageProps = {
    title: string,
}

export const HomePage = HomeFilter.withProvider(filterProviderProps, ({ title }: IHomePageProps) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const [_dataCollectionState, dataCollection, dataCollectionIsLoading] = useFetchData(() => {
        return dataCollectionService.getCollectionObj({
            issueStatReport: DataCollectionCode.DocUpdateIssueStatReport,
            issueSlaReport: DataCollectionCode.DocUpdateIssueSlaReport,
        });
    }, []);

    return (<>
        <TitlePageH1>{title}</TitlePageH1>
        <Grid container
            spacing={2}
            sx={{ maxWidth: '1350px' }}
        >
            <Grid container
                item
                spacing={2}
                direction={'row'}>
                <Grid
                    container
                    item
                    spacing={2}
                    xs={12}
                    sm={12}
                    md={8}
                    alignContent='flex-start'
                >
                    {/* Виджет: начало работы */}
                    <Grid item
                        xs={12}
                        sm={12}
                        md={6}>
                        <BeginningWorkWidget />
                    </Grid>

                    {/* Виджет: статистика */}
                    <Grid item
                        xs={12}
                        sm={12}
                        md={6}>
                        <StatisticsWidget
                            statReportData={dataCollection?.issueStatReport}
                            statReportLoading={dataCollectionIsLoading}
                        />
                    </Grid>

                    {/* Виджет: Время решения, последние 60 дней */}
                    <Grid item
                        xs={12}
                        sm={12}
                        md={12}>
                        <DecisionTimeWidget
                            reportData={dataCollection?.issueSlaReport}
                            reportLoading={dataCollectionIsLoading}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    md={4}
                >
                    <HomeFilter.Component />
                </Grid>
            </Grid>
        </Grid>

    </>);
});
